export type ModalsSeenState = Record<string, string>;

const state: ModalsSeenState = {};

export default state;
